export default "__VITE_ASSET__Cj18TDTv__"